import { message } from 'antd'
import { URL_ENDPOINT_PROJECT } from './constants/config.project'
import {
  ListProjectInput,
  ProjectEntity,
  DetailProjectInput,
  CreateProjectInput,
  BodyUpdateProjectIdWithInputInput,
} from '../../../../server-api-hrm.type'
import axiosClient from '../../../../utils/custom-fetch'
import { MetadataType } from '../../../../utils/metadata.types'

const appEndpoint = URL_ENDPOINT_PROJECT

export type ProjectListVariant = 'for-me' | 'all' | 'not-in-task'

export const getListProject = async (
  token?: string,
  listVariant?: ProjectListVariant,
  body?: ListProjectInput
) => {
  if (!token || !listVariant) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<{
      metadata: MetadataType
      data: ProjectEntity[]
    }>(`${appEndpoint}/list/${listVariant}`, body)
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const getDetailProject = async (
  token?: string,
  body?: DetailProjectInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ProjectEntity>(
      `${appEndpoint}/detail`,
      body
    )
  } catch {
    message.error('Tải dữ liệu thất bại')
  }

  return null
}

export const addProject = async (token?: string, body?: CreateProjectInput) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ProjectEntity>(
      `${appEndpoint}/add`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const updateProject = async (
  token?: string,
  body?: BodyUpdateProjectIdWithInputInput
) => {
  if (!body?.id || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ProjectEntity>(
      `${appEndpoint}/update`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}

export const deleteProject = async (
  token?: string,
  body?: DetailProjectInput
) => {
  if (!body || !token) {
    message.error('Thông tin không hợp lệ')
    return null
  }

  try {
    return await axiosClient(token).post<ProjectEntity>(
      `${appEndpoint}/delete`,
      body
    )
  } catch {
    message.error('Hành động thất bại')
  }

  return null
}
